<template>

	<div class="site-footer mx-auto">
		<b-nav tabs>
			<b-nav-item-dropdown id="footerNav1_ddown" text="Policies" extra-toggle-classes="nav-link-custom" >
				<b-dropdown-item href="#" target="_blank">TOS</b-dropdown-item>
				<b-dropdown-item href="#" target="_blank">Privacy Policy</b-dropdown-item>
				<b-dropdown-item href="#" target="_blank">Disclaimer</b-dropdown-item>
				<b-dropdown-item href="#" target="_blank">Cookie Policy</b-dropdown-item>
			</b-nav-item-dropdown>
			<b-nav-item-dropdown id="footerNav2_ddown" text="Credits" extra-toggle-classes="nav-link-custom" >
		    	<b-dropdown-item href="https://www.cryptocompare.com/" target="_blank">Cryptocurrency Market Data by CryptoCompare.com</b-dropdown-item>
		    </b-nav-item-dropdown>
		    <b-nav-item id="footerNav3" href="#" >Contact Us</b-nav-item>
		</b-nav>

	</div>

</template>

<style>
div.site-footer { position:fixed; bottom:0px; width:100%; z-index: -1}
.site-footer a { font-size: 10pt; color: gray}
</style>


<script>


export default {
  name: '',

  data () {
	  return {

	  }
  },

  mounted: function () {

		this.$nextTick(function () {
			// Code that will run only after the
			// entire view has been rendered

		});
	},

  methods: {

  }

}
</script>





// WEBPACK FOOTER //
// src/components/SiteFooter.vue